// extracted by mini-css-extract-plugin
export var createdDate = "_eq-1";
export var divider = "_eq-2";
export var headerDivider = "_eq-3";
export var messagesCard = "_eq-0";
export var messagesContainer = "_eq-6";
export var messagesContainerWrapper = "_eq-4";
export var showLeftPanelButton = "_eq-8";
export var topButtons = "_eq-7";
export var withPadding = "_eq-5";